import { useEffect, useState } from "react";

const MS_PER_DAY = 86400000;
const WEEKDAY_KO = ["일", "월", "화", "수", "목", "금", "토"];

// 시:분 차이가 아니라 로컬 달력 날짜 차이를 세기 위해 자정으로 정규화.
const startOfLocalDay = (ms: number) => {
  const d = new Date(ms);
  d.setHours(0, 0, 0, 0);
  return d.getTime();
};

// 배너 표기용 종료 일자. 2026-08-09 → "8/9 (일)"
export function formatReferralEndDate(ms: number) {
  const d = new Date(ms);
  return `${d.getMonth() + 1}/${d.getDate()} (${WEEKDAY_KO[d.getDay()]})`;
}

// 제휴 결제 할인(챌린저/마스터 -30,000)의 활성 여부 + 남은 시간을 라이브로 계산.
// expiresAtMs(epoch millis)는 백엔드가 결제페이지 최초 진입 기준 24h + 어트리뷰션 윈도우(마지막 제휴 진입 후 3일) 중
// 먼저 끝나는 쪽으로 eligibility 판정 후 order/detail 로 내려준다(없으면 비활성 — 어트리뷰션 만료 = 오가닉 취급 포함).
// 남은 시간은 1시간 단위로 올림: 23시간 30분 → 24, 1초 → 1.
export default function useReferralDiscount(
  expiresAtMs: number | null | undefined
) {
  // 표시는 시간 단위(올림)라 60초 틱이면 충분 (큰 결제 페이지를 매초 리렌더하지 않도록).
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!expiresAtMs) return;
    const id = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(id);
  }, [expiresAtMs]);

  const remainingMs = expiresAtMs ? expiresAtMs - now : 0;
  const active = !!expiresAtMs && remainingMs > 0;
  // 윈도우는 24h. 클라이언트 시계가 서버보다 뒤지면 remainingMs 가 24h 를 미세 초과해
  // ceil 이 25 가 될 수 있으므로 24 로 캡(표시 상한).
  const hoursLeft = active ? Math.min(24, Math.ceil(remainingMs / 3600000)) : 0;
  // 만료까지 남은 달력 일수(로컬 날짜 기준): 0 = 오늘, 1 = 내일, 2 = 모레. 비활성이면 null.
  // 서머타임으로 하루가 23/25시간이 되는 경우를 대비해 round.
  const daysLeft = active
    ? Math.round(
        (startOfLocalDay(expiresAtMs as number) - startOfLocalDay(now)) /
          MS_PER_DAY
      )
    : null;

  return { active, hoursLeft, daysLeft };
}
